<template>
    <banner-alert
        type="warning"
        :icon="icon"
        :closable="true"
        @close="$emit('close')">
        <div>
            <span class="is-bold">You've reached 80% of your monthly active user (MAU) limit.</span> You're approaching
            the {{ mauLimit.toLocaleString('en') }} MAU threshold of your current Pendo plan. To avoid any interruptions
            in your experience, consider upgrading your plan today.
            <learn-more-link
                type="secondary"
                :href="mauSupportLink" />
        </div>
        <template #actions>
            <pendo-button
                :pendo-analytics="`global-banner:${GLOBAL_BANNER_TYPES.MAU_WARNING}:` + primaryLabel"
                :data-cy="`${primaryLabel}:button`"
                :label="primaryLabel"
                size="mini"
                type="primary"
                @click="$emit('primaryAction')" />
            <pendo-button
                v-if="isEligibleForTrial"
                :pendo-analytics="`global-banner:${GLOBAL_BANNER_TYPES.MAU_WARNING}:Start trial`"
                data-cy="Start trial:button"
                label="Start trial"
                size="mini"
                type="subtle"
                @click="$emit('startTrial')" />
        </template>
    </banner-alert>
</template>

<script>
import BannerAlert from '@/common/banner-notification/banner-alert/banner-alert.vue';
import GLOBAL_BANNER_TYPES from '@/constants/global-banner-types';
import { getPrimaryLabel } from './global-banner-types.utils';
import { PendoButton } from '@pendo/components-vue3';
import LearnMoreLink from '@/common/learn-more-link/learn-more-link.vue';
import { MAU_LIMIT_SUPPORT_ARTICLE_LINK } from '@/free/free.constants.js';

export default {
    name: 'MauWarningBanner',
    components: {
        BannerAlert,
        PendoButton,
        LearnMoreLink,
    },
    props: {
        isEligibleForTrial: {
            type: Boolean,
            required: true,
        },
        mauLimit: {
            type: Number,
            required: true,
        },
        plan: {
            type: String,
            required: true,
        },
        canAccessStarterUpgrade: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'primaryAction', 'startTrial'],
    data () {
        return {
            mauSupportLink: MAU_LIMIT_SUPPORT_ARTICLE_LINK,
            GLOBAL_BANNER_TYPES,
            icon: {
                type: 'alert-triangle',
                stroke: 'var(--palette-yellow-80)',
            },
        };
    },
    computed: {
        primaryLabel () {
            return getPrimaryLabel(this.plan, this.canAccessStarterUpgrade);
        },
    },
};
</script>

<style lang="less" scoped>
.pendo-banner {
    .pendo-alert {
        border: none;
        border-radius: 0;
    }
    .is-bold {
        font-weight: bold;
    }
}
</style>
